
import { seoConfig } from "./config";

interface StructuredDataProps {
  description: string;
  canonicalUrl: string;
}

export const StructuredData = ({ description, canonicalUrl }: StructuredDataProps) => {
  // Ensure canonical URL is absolute
  const absoluteCanonicalUrl = canonicalUrl.startsWith('http') ? canonicalUrl : `${seoConfig.baseUrl}${canonicalUrl}`;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "NLocale",
    "url": absoluteCanonicalUrl,
    "logo": seoConfig.defaultImage,
    "sameAs": Object.values(seoConfig.social),
    "description": description,
    "address": {
      "@type": "PostalAddress",
      "addressRegion": "Hauts-de-France",
      "addressCountry": "FR"
    }
  };

  const websiteJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "NLocale - Découvrez l'Aisne Autrement",
    "url": absoluteCanonicalUrl,
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": `${seoConfig.baseUrl}/search?q={search_term_string}`
      },
      "query-input": "required name=search_term_string"
    }
  };

  const localBusinessJsonLd = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "NLocale",
    "image": seoConfig.defaultImage,
    "description": description,
    "areaServed": {
      "@type": "State",
      "name": "Aisne",
      "address": {
        "@type": "PostalAddress",
        "addressRegion": "Hauts-de-France",
        "addressCountry": "FR"
      }
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "27"
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      "opens": "00:00",
      "closes": "23:59"
    }
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteJsonLd)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessJsonLd)}
      </script>
    </>
  );
};
